<p-toast [preventOpenDuplicates]="true" [baseZIndex]="10500" [autoZIndex]="false" />
<app-loading></app-loading>
<router-outlet></router-outlet>
<app-ai-chat-global-overlay></app-ai-chat-global-overlay>
@if (showFeedbackButton()) {
  <app-floating-feedback-button></app-floating-feedback-button>
}
<app-debug-env></app-debug-env>
